<template>
  <div :style="wrapStyle" :class="getCss('group-team')">
    <!--    <div :class="getCss('rule')" @click="ruleDialogShow = true"-->
    <!--         v-if="configurationData.showRuleDisPlayBtn">成团规则</div>-->
    <div :class="getCss('mainGroupContainer')">
      <div :class="getCss('member')" ref="displayMemberContainer">
        <p
          :class="getCss(['arrow-left','arrow'])"
          v-if="!configurationData.leftBackGroundImage && showArrowIcon"
          @click="touchMovePre"
        >
          <i></i>
        </p>
        <img
          :src="configurationData.leftBackGroundImage"
          v-if="!!configurationData.leftBackGroundImage &&  showArrowIcon"
          :class="getCss('arrow-left-icon')"
          alt
          @click="touchMovePre"
        />
        <div :class="getCss('group-watch-member-window')">
          <div
            :class="getCss('group-watch-member-scroller')"
            ref="groupWatchMemberScroller"
            style="transform: translate3d(0, 0, 0);"
          >
            <ul
              :class="getCss('list')"
              v-for="(team_mates, team_matesIndex) in members"
              :key="team_matesIndex"
            >
              <li :class="getCss('item')" v-for="(member, i) in team_mates" :key="i">
                <template v-if="member.valid">
                  <div :class="getCss('avatar_container')"
                       :style="avatarBackgroundImageStyle"
                  >
                    <img
                      v-if="configurationData.isOpenHeadImgRandom"
                      :class="getCss('avatar')"
                      :src="getHeadImgRandomStyle()"/>
                    <img v-else :class="getCss('avatar')" :src="member.avatar"/>
                  </div>

                  <div :class="getCss('nick')" v-html="member.name"></div>
                  <!--渲染状态提示icon-->
                  <span v-if="statusConfig.statusConditionOption > 0 && !!member.status "
                        :class="getCss(['status-check-show'])">
                    </span>


                  <!--            @click="clickInvite" -->

                </template>
                <template v-else>
                  <img
                    v-show="!!configurationData.avatarBackgroundImage"
                    :class="getCss('avatar')"
                    :src="configurationData.avatarBackgroundImage"
                  />
                  <div
                    :class="getCss('add-icon')"
                    v-show="!configurationData.avatarBackgroundImage"
                  >
                    <div :class="getCss('add-icon-across')"></div>
                    <div :class="getCss('add-icon-vertical')"></div>
                  </div>
                </template>
              </li>
            </ul>
          </div>
        </div>

        <img
          :src="configurationData.rightBackGroupImage"
          v-if="!!configurationData.rightBackGroupImage && showArrowIcon"
          :class="getCss('arrow-right-icon')"
          alt
          @click="touchMoveNext"
        />
        <p
          :class="getCss(['arrow-right','arrow'])"
          v-if="!configurationData.rightBackGroupImage && showArrowIcon"
          @click="touchMoveNext"
        >
          <i></i>
        </p>
      </div>
      <div :class="getCss('team-btn-area')" v-if="!onlyRead">
        <!--   begin 退出队伍 -->
        <div v-if="!configurationData.quitTeamBtnImage && showQuitTeamBtn"
             @click="quitTeam"
             :class="getCss(['team-action—btn','team-action—btn-active'])">
          退出小队
        </div>

        <div v-if="!!configurationData.quitTeamBtnImage && showQuitTeamBtn"
             @click="quitTeam"
             :class="getCss('team-action-image')">
          <img :src="configurationData.quitTeamBtnImage" alt="">
        </div>
        <!--   end  退出队伍 -->
        <!--   begin 邀请好友 -->
        <div v-if="!configurationData.inviteTeamBtnImage && showInviteTeamBtn"
             @click="clickInvite"
             :class="getCss(['team-action—btn','team-action—btn-active'])">
          邀请好友
        </div>
        <div v-if="!!configurationData.inviteTeamBtnImage && showInviteTeamBtn"
             @click="clickInvite"
             :class="getCss('team-action-image')">
          <img :src="configurationData.inviteTeamBtnImage" alt="">
        </div>
        <!--   end  邀请好友 -->
        <!--   begin 确认队伍 -->
        <div v-if="!configurationData.confirmTeamBtnImage && showConfirmTeamBtn"
             @click="clickConfirmCreateTeam"
             :class="getCss(['team-action—btn','team-action—btn-active'])">
          确认组队
        </div>
        <div v-if="!!configurationData.confirmTeamBtnImage && showConfirmTeamBtn"
             @click="clickConfirmCreateTeam"
             :class="getCss('team-action-image')">
          <img :src="configurationData.confirmTeamBtnImage" alt="">
        </div>
        <!--   end 确认队伍 -->

        <!--   begin 创建队伍按钮 -->
        <div v-if="!configurationData.createTeamBtnImage && showCreateTeamBtn"
             @click="clickCreateTeam"
             :class="getCss(['team-action—btn','team-action—btn-active'])">
          创建队伍
        </div>
        <div v-if="!!configurationData.createTeamBtnImage && showCreateTeamBtn"
             @click="clickCreateTeam"
             :class="getCss('team-action-image')">
          <img :src="configurationData.createTeamBtnImage" alt="">
        </div>
        <!--   end 创建队伍 -->

        <!--   begin 刷新状态按钮 -->
        <div v-if="!statusConfig.refreshTeamBtnImage && showRefreshTeamBtn"
             @click="refreshMemberStatus"
             :class="getCss(['team-action—btn','team-action—btn-active'])">
          刷新状态
        </div>
        <div v-if="!!statusConfig.refreshTeamBtnImage && showRefreshTeamBtn"
             @click="refreshMemberStatus"
             :class="getCss('team-action-image')">
          <img :src="statusConfig.refreshTeamBtnImage" alt="">
        </div>
        <!--   end 刷新状态按钮 -->
      </div>

      <div v-if="!!configurationData.showGroupNum"
           :class="getCss('top-text')">队伍人数：{{ teamInfo.team_mates.length }}
      </div>

    </div>

    <!--  组队规则-->
    <!--    <c-base-dialog-->
    <!--        v-model="ruleDialogShow"-->
    <!--        :option="ruleOption"-->
    <!--        @close="ruleDialogShow= false"-->
    <!--        @confirm="ruleDialogShow= false"-->
    <!--        v-transfer-dom-->
    <!--    >-->
    <!--      <template slot="body">-->
    <!--        <div-->
    <!--            :class="getCss('dialog-content')" v-html="configurationData.ruleText"-->
    <!--        ></div>-->
    <!--      </template>-->
    <!--    </c-base-dialog>-->
    <!--    邀请弹框-->
    <c-base-dialog
      v-model="inviteDialogShow"
      :option="inviteOption"
      @close="closeInviteDialog"
      @confirm="joinTeam"
      @cancel="closeInviteDialog"
      v-transfer-dom
    >
      <template slot="body">
        <div
          :class="getCss('dialog-content')"
        >
          <p :class="getCss('invite_name')" v-html="`你的好友：${inviteInfo.inviter_name}`"></p>
          <img v-if="inviteInfo.inviter_avatar"
               :class="getCss('invite_avatar')" :src="inviteInfo.inviter_avatar" alt="">
          <p>{{ configurationData.inviteJoinTips }}</p>
          <div>
            <span :style="confirmBtnStyle" :class="getCss('confirm-btn')" @click="joinTeam"></span>
            <span :style="cancelBtnStyle" :class="getCss('confirm-btn')" @click="closeInviteDialog"></span>
          </div>
          <p>{{ configurationData.inviteBottomText }}</p>
        </div>
      </template>
    </c-base-dialog>
    <!-- 提示弹窗 -->
    <c-base-dialog
      v-model="showErrorTips"
      :option="showErrorTipsOption"
      @close="closeErrorTipsDialog"
      @confirm="closeErrorTipsDialog"
      v-transfer-dom
    >
      <template slot="body">
        <div
          :class="getCss('dialog-content')"
        >
          <p>{{ errorMsg }}</p>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CTgclubGroupTeam',
  components: {
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-group-team-',
      // 当前滚动的index
      currentIndex: 0,
      // 队伍信息
      teamInfo: {
        current_mate: 0, // 当前队伍人数
        limit_mate: 0, // 0-无上限
        exist: 0, // 0-不存在，1-存在
        exit: 0, // 0-不可以退出，1-可以退出
        leader: 0, // 0-不是队长，1-是队长
        team_name: '', // 队名称
        confirm: 0, // 0-未成团，1-成团
        team_mates: [],
        // team_mates[]{leader,name,avatar}
      },
      // 邀请人邀请码
      inviteCode: '',
      //  邀请信息
      inviteInfo: {
        team_name: '',
        inviter_name: '',
        inviter_avatar: '',
      },
      // 自己的邀请码
      selfInviteCode: '',
      // 是否初始化
      init: false,
      // 邀请弹框
      inviteDialogShow: false,
      // 提示弹窗
      showErrorTips: false,
      errorMsg: '',
      // 加入弹框
      // // 获取规则弹框
      // ruleDialogShow: false,
    };
  },

  computed: {
    confirmBtnStyle() {
      return Object.assign({}, this.dialogConfig?.confirmStyle?.backgroundImage
        ? this.dialogConfig.confirmStyle : {
          background: this.dialogConfig?.dialogStyle?.color,
        });
    },
    cancelBtnStyle() {
      return Object.assign({}, this.dialogConfig?.cancelStyle?.backgroundImage
        ? this.dialogConfig.cancelStyle : {
          background: this.dialogConfig?.dialogStyle?.color,
        });
    },
    avatarBackgroundImageStyle() {
      return {
        backgroundImage: `url(${
          this.configurationData.avatarBackgroundImage || ''
        })`,
      };
    },
    canQuitTeamBeforeConfirm() {
      return this.configurationData.canQuitTeamBeforeConfirm;
    },
    showArrowIcon() {
      return this.configurationData.rowSize < this.configurationData.groupTotalSize;
    },
    statusConfig() {
      return this.configurationData.statusConfig || {
        statusConditionOption: 0,
        // 0  没有状态
        // 1  成团的必备条件之一
        // 2  仅做展示
        statusCheckFlowId: '',
        statusCheckErrorText: '还未在游戏内体验语音助手哦',
        refreshTeamBtnImage: '',
      };
    },
    wrapStyle() {
      const fontStyle = this.styles.fontStyle || {};
      return {
        ...this.styles.base,
        ...fontStyle,
      };
    },
    // 退出队伍
    showQuitTeamBtn() {
      return (this.teamInfo.exist === 1 && this.teamInfo.confirm === 0 && this.init
        && this.canQuitTeamBeforeConfirm) || this.$isInEditor;
    },
    groupTotalSize() {
      return this.configurationData.groupTotalSize;
    },
    // 邀请队伍
    showInviteTeamBtn() {
      return (this.teamInfo.current_mate >= 1
        && this.teamInfo.current_mate < this.configurationData.groupTotalSize && this.init
        && this.teamInfo.confirm !== 1) || this.$isInEditor;
    },
    isAPP() {
      return this.$ast.isAPP();
    },
    //  确认队伍
    showConfirmTeamBtn() {
      return (this.teamInfo.current_mate >= this.configurationData.groupTotalSize
        && this.teamInfo.confirm === 0 && this.teamInfo.leader === 1 && this.init) || this.$isInEditor;
    },
    // 创建队伍
    showCreateTeamBtn() {
      return (this.teamInfo.current_mate === 0) || this.$isInEditor;
    },
    showRefreshTeamBtn() {
      return (this.statusConfig.statusConditionOption > 0 && this.init && this.teamInfo.current_mate > 0)
        || (this.$isInEditor && this.statusConfig.statusConditionOption > 0);
    },
    members() {
      const list = [];
      let temp = [];
      //  一排多少个 groupTotalSize = 0
      const { rowSize = 0 } = this.configurationData;
      console.log('rowSize = ', rowSize);
      // 有多少人
      const { length } = this.teamInfo.team_mates;
      for (let i = 0; i <= length - 1; i++) {
        temp.push({ ...this.teamInfo.team_mates[i], valid: true });
        if (temp.length === rowSize) {
          list.push(temp);
          temp = [];
        }
      }
      // 剩余的 未满足5个
      if (temp.length > 0) {
        list.push([...temp, ...new Array(rowSize - temp.length).fill({ valid: false })]);
      }
      //  最后一排刚好满5个 在添加1排
      if (length % rowSize === 0) {
        list.push([...new Array(rowSize).fill({ valid: false })]);
      }
      console.log('list=', list);
      return list;
    },

    inviteOption() {
      const extend = {
        height: 'auto',
        fotter: true,
        header: '邀请组队',
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
        close: true,
      };
      return Object.assign({}, this.dialogConfig, extend);
    },
    isNeedBindRole() {
      return this.configurationData.needRoleInfo;
    },
    onlyRead() {
      return this.configurationData.onlyRead || false;
    },
    showErrorTipsOption() {
      const extend = {
        fotter: true,
        confirm: this.dialogConfig?.confirmStyle?.backgroundImage ? true : '好的',
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
        confirmStyle: Object.assign({}, this.dialogConfig?.confirmStyle?.backgroundImage
          ? this.dialogConfig.confirmStyle : {
            width: '2.2rem',
            background: this.dialogConfig?.dialogStyle?.color,
          }),
        close: true,
      };
      return Object.assign({}, this.dialogConfig, extend);
    },
  },
  async mounted() {
    console.log(' version 1.0.10 tgclub-join-team configurationData=', this.configurationData, this.dialogConfig);
    // this.$isInEditor = true;
    await this.initialize();
    this.initListenScrollerEvent();
  },
  destroyed() {
    this.removeScrollerEvent();
  },
  methods: {
    // 检测组队是否需要 角色
    checkHasRole() {
      if (!this.roleInfo.role_id && this.isNeedBindRole) {
        this.$alert({ msg: '请先绑定角色' });
        return false;
      }
      return true;
    },
    getErrorMsg(statusCode) {
      const map = {
        10001: '服务器繁忙',
        10002: '参数错误',
        10003: '记录不存在',
        10004: '查询的记录不存在',
        10005: '更新失败',
        10006: '账号异常，请稍后重试',
        10007: '服务器繁忙(10007)',
        10008: '操作权限不足',
        11000: '邀请码已失效',
        11001: '你已在别的队伍中，去获取组队奖励吧~',
        11002: '队伍已满，去创建属于你的队伍吧',
        11003: '加入队伍失败，请稍后重试',
        10013: '未加入任何队伍',
        10014: '你已加入该队伍',
        10015: '不能邀请自己哦~',
        10016: '队伍已确定成团，无法退出队伍', // 已成团
        10017: '此队伍人数已满',
        10018: '队伍中存在其他队员，队长无法退出',
        10020: '退出队伍失败，请稍后重试',
        10019: '此队伍不允许退出',
        10022: '无法确定成团,队伍还未满员',
      };
      return map[statusCode] || '';
    },
    //  创新状态按钮
    async refreshMemberStatus() {
      const { statusCheckFlowId = 0, statusConditionOption = 0 } = this.statusConfig;
      if (statusCheckFlowId === 0 || statusConditionOption === 0) {
        return false;
      }
      const { team_mates: teamMates = [] } = this.teamInfo;
      if (teamMates.length === 0) {
        return false;
      }
      const that = this;
      const promiseList = teamMates.map(item => that.flowRequest({
        flowId: statusCheckFlowId,
        params: {
          data: JSON.stringify({ gameOpenId: item.game_openid || '' }),
          role: this.roleInfo,
        },
      }));
      const resAll = (await Promise.allSettled(promiseList))
        .filter(request => request.status === 'fulfilled')
        .map(request => request.value);
      console.log('refreshMemberStatus promiseList,resAll ', promiseList, resAll);
      for (let i = 0; i <= teamMates.length - 1; i++) {
        const { data = {} } = resAll[i] || {};
        const { status = 0, count = 0 } = data;
        let member = teamMates[i] || {};
        member = {
          ...member,
          status: !!(status > 0 || count > 0),
        };
        teamMates[i] = member;
      }
      this.$set(this.teamInfo, 'team_mates', [...teamMates]);
      // this.teamInfo.team_mates = teamMates;
      console.log('refreshMemberStatus after this.teamInfo', this.teamInfo);
      this.toast('状态刷新成功');
      return true;
    },
    //  查询队员完成状态  成团的必备条件之一
    async checkMemberStatus() {
      const { statusCheckFlowId = 0, statusConditionOption = 0, statusCheckErrorText } = this.statusConfig;
      if (statusConditionOption !== 1 && statusConditionOption !== 2) {
        return true;
      }
      const that = this;
      const { team_mates: teamMates = [] } = this.teamInfo;
      if (teamMates.length === 0) {
        return false;
      }
      const promiseList = teamMates.map(item => that.flowRequest({
        flowId: statusCheckFlowId,
        params: {
          data: JSON.stringify({ gameOpenId: item.game_openid || '' }),
          role: this.roleInfo,
        },
      }));
      const resAll = (await Promise.allSettled(promiseList)).filter(request => request.status === 'fulfilled')
        .map(request => request.value);
      console.log('refreshMemberStatus promiseList,resAll ', promiseList, resAll);
      for (let i = 0; i <= teamMates.length - 1; i++) {
        const { data = {} } = resAll[i] || {};
        const { status = 0, count = 0 } = data;
        if (status === 0 && count === 0) {
          const member = teamMates[i] || {};
          if (member.name) {
            this.$alert({ msg: `${member.name || ''}${statusCheckErrorText}` });
            return false;
          }
        }
      }
      return true;
    },
    //  初始化
    async initialize() {
      if (this.onlyRead) {
        this.$onLogined(async () => {
          // console.log('onlogined', this.userInfo, this.roleInfo);
          try {
            await this.getTeamInfoByOnlyRead();
            this.init = true;
          } catch (e) {
            console.log('initialize login error =', e);
          }
        });
      } else {
        this.$onLogined(async () => {
          this.getInviteCodeFromUrl(); //  获取inviteCode
          console.log('onlogined', this.userInfo, this.roleInfo);
          try {
            // 主态
            await this.getTeamInfo();
            console.log('teamInfo=', this.teamInfo);
            console.log('inviteCode=', this.inviteCode);
            // 是否邀请码  有邀请码 且不在app 内
            if (this.inviteCode && !this.isAPP) {
              await this.getTeamInviteInfo();
            }
            this.init = true;
          } catch (e) {
            console.log('initialize login error =', e);
          }
        });
      }
    },
    // todo 尝试判断 自己的角色game_open_id  在不在队伍中 重而能避免自己加入队伍多次弹出
    tryToCheckRoleGameOpenIdIsInTeam() {
      const { game_open_id: gameOpenId = '' } = this.roleInfo || {};
      const { team_mates: teamMates = [] } = this.teamInfo || [];
      return teamMates.findIndex(item => item.game_openid === gameOpenId) > -1;
    },
    // 退出组队
    async quitTeam() {
      if (!this.canQuitTeamBeforeConfirm) {
        this.toast('队伍不能退出');
        return false;
      }
      const that = this;

      // ### 退出队伍
      async function func() {
        const response = await this.flowRequest({
          flowId: this.configurationData.quitTeamFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        const { ret, msg, data = {} } = response;
        const { ret: resRet, msg: resMsg } = data;
        if (resRet !== 0) {
          this.reportFunc('team_exit', '0');
          this.$alert({ msg: resMsg || '操作失败' });
          return false;
        }
        const { status = 0 } = data;
        if (status !== 0) {
          this.reportFunc('team_exit', '0');
          this.closeInviteDialog();
          if (status === 11001 || status === 10017) {
            this.errorMsg = this.getErrorMsg(status);
            this.showErrorTips = true;
          } else {
            this.$alert({ msg: this.getErrorMsg(status) });
          }
          return false;
        }
        if (ret !== 0) {
          this.toast(msg || '操作失败');
          this.reportFunc('team_exit', '0');
        } else {
          this.toast('操作成功！');
          this.getTeamInfo();
          this.reportFunc('team_exit', '1');
        }
      }

      // ### 退出队伍
      this.$confirm({
        msg: this.teamInfo.leader >= 0 ? '队长退出会解散队伍,确定退出队伍吗？' : '确定退出队伍吗？',
        confirm() {
          console.log('确定队伍');
          func.apply(that);
        },
      });
    },
    reportFunc(eventKey, status) {
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey,
          eventData: {
            status,
          },
        };
        this.reportClickRaw(params);
        console.log(`reportFunc  group team ${eventKey}  data =`, params);
      }
    },
    confirmTeamCallBack() {
      const { confirmTeamCallBackFlowId } = this.configurationData;
      console.log('confirmTeamCallBack confirmTeamCallBackFlowId', confirmTeamCallBackFlowId);
      if (confirmTeamCallBackFlowId <= 0) {
        return;
      }
      this.flowRequest({
        flowId: confirmTeamCallBackFlowId,
        params: {
          role: this.roleInfo,
        },
      }).then((response) => {
        console.log(' confirmTeamCallBack callback response', response);
        const { ret } = response;
        if (ret === 0) {
          this.refreshQua(); // 刷新资格
          console.log(' confirmTeamCallBack refreshQua callback response');
          this.toast('队长成团后奖励已发送！');
        }
      });
    },
    // 确认成团
    async clickConfirmCreateTeam() {
      const res = await this.checkMemberStatus();
      if (!res) {
        return false;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.confirmTeamFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      const { ret: rspRet, msg: rspMsg } = response || {};
      if (rspRet !== 0) {
        this.reportFunc('team_confirm', '0');
        return this.$alert({ msg: rspMsg || '操作失败' });
      }
      const { ret, msg, status = 0 } = response.data || {};
      if (status !== 0) {
        this.reportFunc('team_confirm', '0');
        return this.$alert({ msg: this.getErrorMsg(status) });
      }
      if (ret !== 0) {
        this.reportFunc('team_confirm', '0');
        return this.$alert({ msg: msg || '操作失败' });
      }
      this.toast('队长确定成团操作成功');
      this.getTeamInfo();
      this.confirmTeamCallBack();
      this.reportFunc('team_confirm', '1');
    },
    closeInviteDialog() {
      this.inviteCode = '';
      this.inviteDialogShow = false;
    },
    // 加入队伍
    async joinTeam() {
      this.inviteCode || this.getInviteCodeFromUrl();
      if (!this.inviteCode) {
        return false;
      }
      if (!this.checkHasRole()) {
        this.$onRoleReady(async () => {
          if (!this.hasAccssJoinTeam) {
            this.hasAccssJoinTeam = true;
            await this.joinTeam();
          }
        });
        return false;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.joinTeamFlowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({
            invite_code: this.inviteCode,
            name: this.userInfo.nickName,
            avatar: this.userInfo.avatar,
          }),
        },
      });
      console.log('joinTeam response=', response);
      const { ret: resRet, msg: resMsg } = response;
      if (resRet !== 0) {
        this.reportFunc('team_join', '0');
        this.$alert({ msg: resMsg });
        return false;
      }
      const { ret, msg = '加入队伍失败', status = 0 } = response.data || {};
      if (ret !== 0) {
        this.reportFunc('team_join', '0');
        this.$alert({ msg });
        return false;
      }
      if (status !== 0) {
        this.closeInviteDialog();
        this.reportFunc('team_join', '0');
        if (status === 11001 || status === 10017 || status === 10016) {
          this.errorMsg = this.getErrorMsg(status);
          this.showErrorTips = true;
        } else {
          this.$alert({ msg: this.getErrorMsg(status) });
        }
        return false;
      }
      // 刷新队伍
      this.getTeamInfo();
      this.closeInviteDialog();
      this.inviteCode = '';
      this.selfInviteCode = '';
      this.$alert({ msg: this.configurationData.successJoinTeamTips || '加入成功' });
      this.reportFunc('team_join', '1');
      const { joinTeamAutoGameBook = false } = this.configurationData;
      if (joinTeamAutoGameBook === true) {
        this.broadcastGameBookResult(true);
      }
    },
    //  存在多个预约地方的时候  同步
    broadcastGameBookResult(val) {
      this.$eventBus.$emit('ceiba:custom:events:game:book:result', { status: val });
    },
    // 获取链接上的邀请码
    getInviteCodeFromUrl() {
      this.inviteCode = common.tool.getQueryparams('inviter_code') || '';
    },
    // 点击邀请
    async clickInvite() {
      if (this.configurationData.forceApp && !this.$ast.isAPP()) {
        return this.$ast.gotoAPP();
      }
      console.log('clickInvite', this.userAuth, this.isLogin);
      if (!this.isLogin || !this.init) {
        this.alert('请先登录');
        return;
      }
      if (!this.selfInviteCode) {
        const res = await this.getInviteCode();
        if (!res) return false;
      }
      const link = common.tool.setUrlParam('inviter_code', this.selfInviteCode, window.location.href);
      console.log('inviteLink=', link);
      this.reportFunc('share', '1');
      this.$ast.setAPPShare({
        ...this.shareConfig,
        link,
        icon: this.shareConfig?.icon || '',
        title: this.configurationData.inviteJoinTitle || '邀请组队',
        desc: this.configurationData.inviteJoinTips || '邀请你组队',
      });
      this.$ast.goAPPShare();
    },
    // 获取自己的邀请码
    async getInviteCode() {
      const response = await this.flowRequest({
        flowId: this.configurationData.queryInviteCodeFlowId,
        params: {
          data: JSON.stringify({
            name: this.userInfo.nickName,
            avatar: this.userInfo.avatar,
          }),
        },
      });
      console.log('response=', response);
      const { ret, msg, data } = response;
      if (ret !== 0) {
        this.toast(msg || '获取邀请码失败');
        return false;
      }
      const { ret: resRet, msg: resMsg } = data;
      if (resRet !== 0) {
        this.$alert({ msg: resMsg || '获取邀请码失败' });
        return false;
      }
      const { data: rsp, status = 0 } = data || {};
      if (status !== 0) {
        this.toast(this.getErrorMsg(status));
        return false;
      }
      this.selfInviteCode = rsp.invite_code || '';
      console.log('get new  selfInviteCode =  ', this.selfInviteCode);
      return true;
    },
    // 点击创建队伍
    async clickCreateTeam() {
      if (!this.isLogin) {
        this.$alert({ msg: '请先登录' });
        return false;
      }
      if (!this.checkHasRole()) {
        return false;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.createTeamFlowId,
        params: {
          // role: this.roleInfo,
          data: JSON.stringify({
            name: this.userInfo.nickName,
            avatar: this.userInfo.avatar,
            team_name: '',
            exit: 1, // 1 可退出 0 没有退出
            limit_mate: this.configurationData.groupTotalSize || 3,
          }),
        },
      });
      console.log('response=', response);
      const { ret, msg, data = {} } = response;
      const { status = 0 } = data;
      if (status !== 0) {
        this.reportFunc('team_create', '0');
        this.$alert({ msg: this.getErrorMsg(status) });
        return false;
      }
      if (ret !== 0) {
        this.reportFunc('team_create', '0');
        return this.toast(msg || '创建队伍失败');
      }
      const { ret: resRet, msg: resMsg } = data;
      if (resRet !== 0) {
        this.reportFunc('team_create', '0');
        return this.toast(resMsg || '创建队伍失败');
      }
      this.getTeamInfo();
      this.toast('创建队伍成功');
      this.reportFunc('team_create', '1');
      const { createTeamAutoGameBook = false } = this.configurationData;
      if (createTeamAutoGameBook === true) {
        this.broadcastGameBookResult(true);
      }
      return true;
    },
    // 获取自己的队伍
    async getTeamInfo() {
      if (!this.configurationData.queryTeamFlowId) {
        return;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.queryTeamFlowId,
      });
      console.log('getTeamInfo response= ', response);
      const pureTeamInfo = {
        current_mate: 0, // 当前队伍人数
        limit_mate: 0, // 0-无上限
        exist: 0, // 0-不存在，1-存在
        exit: 0, // 0-不可以退出，1-可以退出
        leader: 0, // 0-不是队长，1-是队长
        team_name: '', // 队名称
        confirm: 0, // 0-未成团，1-成团
        team_mates: [],
        // team_mates[]{leader,name,avatar,gameOpenId}
      };
      const { ret: rspRet, msg: rspMsg, data = {} } = response;
      if (rspRet !== 0) {
        this.teamInfo = pureTeamInfo;
        this.$alert({ msg: rspMsg || '获取队员信息失败' });
        return;
      }

      const { ret, msg, data: rsp, status = 0 } = data;

      if (ret !== 0 || status !== 0) {
        this.toast(msg || this.getErrorMsg(status));
        this.teamInfo = pureTeamInfo;
        return;
      }
      this.teamInfo = rsp.team_mates ? { ...{ exit: 1, confirm: 0 }, ...rsp } : pureTeamInfo;
      console.log('reponse this.teamInfo= ', this.teamInfo);
      if (this.teamInfo.team_mates && this.teamInfo.team_mates.length > 0) {
        this.refreshMemberStatus();
      }
    },
    async getTeamInfoByOnlyRead() {
      const params = {
        business: this.configurationData.onlyReadbusiness || this.$actInfo.ast,
        activity: this.configurationData.onlyReadActivity || this.$actInfo.activity_id,
        ext: JSON.stringify({
          name: this.userInfo.nickName,
          avatar: this.userInfo.avatar || 'https://game.gtimg.cn/images/js/img/lottery/default_head.png',
        }),
      };
      console.log('getTeamInfoByOnlyRead', this.userInfo, params);
      // const response = await this.$requestInstance.post('Ceiba.PlaySrv/GetTeamInfo', params);
      const response = await this.$requestInstance.post('Ceiba.PlaySrv/TeamGetInfo', params);
      console.log('getTeamInfo response= ', response);
      const pureTeamInfo = {
        current_mate: 0, // 当前队伍人数
        limit_mate: 0, // 0-无上限
        exist: 0, // 0-不存在，1-存在
        exit: 0, // 0-不可以退出，1-可以退出
        leader: 0, // 0-不是队长，1-是队长
        team_name: '', // 队名称
        confirm: 0, // 0-未成团，1-成团
        team_mates: [],
        // team_mates[]{leader,name,avatar,gameOpenId}
      };
      const { ret: rspRet, data = {} } = response;
      console.log('getTeamInfo response= ', data);
      if (rspRet !== 0) {
        this.teamInfo = pureTeamInfo;
        return;
      }
      this.teamInfo = data.team_mates ? { ...{ exit: 1, confirm: 0 }, ...data } : pureTeamInfo;
      console.log('reponse this.teamInfo= ', this.teamInfo);
      if (this.teamInfo.team_mates && this.teamInfo.team_mates.length > 0) {
        this.refreshMemberStatus();
      }
    },
    // 获取邀请信息
    async getTeamInviteInfo() {
      const response = await this.flowRequest({
        flowId: this.configurationData.queryInviteInfoFlowId,
        params: {
          data: JSON.stringify({
            invite_code: this.inviteCode,
            // role: this.roleInfo,
          }),
        },
      });
      console.log('TeamInviteInfo response= ', response);
      const { data, ret: rspRet } = response;
      const { ret, msg, data: rsp, status = 0 } = data || {};
      const pure = {
        team_name: '',
        inviter_name: '',
        inviter_avatar: '',
      };
      if (status !== 0) {
        const errMsg = this.getErrorMsg(status);
        console.log(' -- getTeamInviteInfo-- error  code = ', status, errMsg);
        return response;
      }
      const tryToCheckRes = this.tryToCheckRoleGameOpenIdIsInTeam();
      console.log('tryToCheckRes', tryToCheckRes);
      const { self = 0 } = rsp || {};
      // const inTeam = rsp?.in_team ? rsp.in_team : 0;
      // self = 1 则自己邀请自己
      if (self === 1) {
        this.errorMsg = this.getErrorMsg(10015);
        this.showErrorTips = true;
        return response;
      }
      // tryToCheckRes 组队的openid 在 游戏角色信息的openid获得匹配
      if (ret !== 0 || rspRet !== 0) {
        this.inviteInfo = pure;
        console.log(' -- getTeamInviteInfo-- error msg ', msg);
        return response;
      }
      this.inviteInfo = rsp || pure;
      // 加入信息
      this.inviteDialogShow = true;
      return response;
    },

    // begin ####################### 组队组队
    removeScrollerEvent() {
      if (this.scrollContainerMain) {
        this.scrollContainerMain.removeEventListener('touchstart', this.touchStartEvent);
        this.scrollContainerMain.removeEventListener('touchend', this.touchEndEvent);
      }
    },
    touchStartEvent(event) {
      event.stopPropagation();
      this.delta = this.delta || {};
      this.delta.x = event.touches[0].pageX;
      this.delta.y = event.touches[0].pageY;
    },
    touchMovePre() {
      const { currentIndex } = this;
      if (currentIndex - 1 >= 0) {
        this.touchMoveEvent(currentIndex - 1);
      }
    },
    touchMoveNext() {
      const { currentIndex } = this;
      if (currentIndex + 1 <= this.members.length - 1) {
        this.touchMoveEvent(currentIndex + 1);
      }
    },
    touchMoveEvent(Index) {
      this.currentIndex = Index;
      this.$refs.groupWatchMemberScroller.style.webkitTransform = `translate3d(${-1 * Index * 6}rem, 0, 0)`;
    },
    touchEndEvent(event) {
      event.stopPropagation();
      let { x, y } = this.delta;
      x -= event.changedTouches[0].pageX;
      y -= event.changedTouches[0].pageY;
      // 向左或向右滑动 距离不够
      if (Math.abs(x) < 5 && Math.abs(y) < 5) {
        return false;
      }
      const { currentIndex } = this;
      // 一定有向左滑动或向右滑动
      if (Math.abs(x) >= Math.abs(y)) {
        if (x > 0) {
          // ,右滑
          if (currentIndex + 1 <= this.members.length - 1) {
            this.touchMoveEvent(currentIndex + 1);
          }
        } else {
          // ,左滑
          if (currentIndex - 1 >= 0) {
            this.touchMoveEvent(currentIndex - 1);
          }
        }
      }
    },
    // 增加监听
    initListenScrollerEvent() {
      if (this.members.length <= 1) {
        return false;
      }
      this.scrollContainerMain = this.$refs.displayMemberContainer;
      this.delta = {};
      //  开始滑动
      this.scrollContainerMain.addEventListener('touchstart', this.touchStartEvent);
      //  滑动结束
      this.scrollContainerMain.addEventListener('touchend', this.touchEndEvent);
    },
    // end ####################### 组队组队
    closeErrorTipsDialog() {
      this.showErrorTips = false;
    },
    // 获取随机头像
    getHeadImgRandomStyle() {
      const randomNum = Math.floor(Math.random() * this.configurationData.packagePosition.length);
      return this.configurationData.packagePosition[randomNum].packageImg || '';
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
